export default "__VITE_ASSET__CWPbe83$__"